<template>
  <div id="app">
    <router-view :key="key"></router-view>
  </div>
</template>git

<script>

export default {
  name: 'app',
  computed:{
		key(){
			return this.$route.path + Math.random();
		}
	}

}
</script>
<style>
  body{ background:#eff2f9; min-height:100%;}
  .form_page{ background:#fff !important;}
  .person_top{ height:129px !important;}
  .form_btm{ margin:0 auto !important;}
  .person_top .top_rt{ bottom:25px !important;}
  .index_top .box dd span{ margin:0 3px !important;}
</style>

